<template>
  <v-expansion-panel :id="id" class="helmi-form__scroll-target">
    <v-expansion-panel-header
      :color="active ? colors.text : 'grey--text text--darken-1'"
      ripple
    >
      <template #default="{ open }">
        <div
          :id="`${id}-anchor`"
          class="helmi-form__scroll-target--anchor"
        />
        <v-row
          align="center"
          class="spacer"
          no-gutters
        >
          <v-col cols="auto">
            <v-chip
              class="ml-0 mr-4 black--text"
              :color="colors.base"
              :text-color="open ? 'white' : colors.text"
              :outlined="!open"
              small
              v-text="chapter"
            />
          </v-col>

          <v-col>
            <strong v-text="$attrs.label"/>
          </v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content
      class="pt-4"
      eager
    >
      <v-row>
        <template
          v-for="(child, key, index) in children"
        >
          <component
            :is="child.component"
            v-if="!child.hide"
            :id="key"
            :key="`${child.chapter || index}_${key}`"
            v-model="child.value"
            v-bind="{ ...options.fieldProps, ...child.props }"
            :chapter="child.chapter"
            :class="{ 'helmi-form-element--hidden': child.hidden }"
            :classes="child.classes || ''"
            :colors="colors"
            :container-props="child.container"
            :container-options="options.containerProps"
            :options="child.options"
            :property-value="child.propertyValue"
            @evaluate="$emit('evaluate', $event, key)"
          />
        </template>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'HelmiSection',

  components: {
    'helmi-checkbox': () => import('@/components/formElements/Checkbox'),
    'helmi-date-picker': () => import('@/components/formElements/DatePicker'),
    'helmi-radiogroup': () => import('@/components/formElements/RadioGroup'),
    'helmi-select': () => import('@/components/formElements/Select'),
    'helmi-spacer': () => import('@/components/formElements/Spacer'),
    'helmi-subheader': () => import('@/components/formElements/Subheader'),
    'helmi-text-field': () => import('@/components/formElements/TextField'),
    'helmi-textarea': () => import('@/components/formElements/TextArea'),
    'helmi-title': () => import('@/components/formElements/Title'),
  },

  inheritAttrs: false,

  props: {
    active: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      default: '',
    },

    children: {
      type: Object,
      default: () => ({}),
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    options: {
      type: Object,
      default: () => ({}),
    },

    chapter: {
      type: String,
      default: '',
    },

    condition: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    modelValue: '',
  }),

  watch: {
    // Handles internal model changes.
    modelValue(newVal) {
      this.$emit('input', newVal);
    },

    // Handles external model changes.
    '$attrs.value': {
      handler(val) {
        if (!val) return;
        this.modelValue = val;
      },
      immediate: true,
    },
  },
};
</script>
